<template>
    <div class="com-partm1">
        <MyTitle title="服务器概览" />
        <div class="p-content flex align-center">
            <img class="img flexs" :src="require('@/assets/images/computility/dispatch-icon4.png')" alt="" />
            <div class="i-list flex flex1">
                <div class="list-all flex flex-direction align-center justify-center flexs">
                    <dv-digital-flop style="height: 80px; width: 100%" :config="dvDigitalFlopConfig(allNum)" />
                    <div class="fs-24 mt-10">总数(台)</div>
                </div>
                <div class="flex1 flex flex-direction justify-center ">
                    <div
                        v-for="(item, i) in list"
                        :key="'list' + i"
                        class="item flex align-center">
                        <div class="item-l flexs" :style="{'background': item.color}"></div>
                        <div class="item-c flexs" :style="{'color': item.color}">{{ item.label }}</div>
                        <div class="item-r flex1">
                            <dv-digital-flop style="height: 30px; width: 100%" :config="dvDigitalFlopConfig(item)" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import MyTitle from './myTitle1.vue'
import { dataInterface } from "@/api/dataInterfaceApi"
export default {
    components: {
        MyTitle
    },
    data() {
        return {
            allNum: {
                value: 75,
                fontSize: 90
            },
            list: [
                {
                    label: '运行中',
                    value: '75',
                    color: '#28C89A',
                    textAlign: 'left'
                },
                {
                    label: '关机',
                    value: '0',
                    color: '#FFFFFF',
                    textAlign: 'left'
                },
                {
                    label: '其他',
                    value: '0',
                    color: '#FFD15C',
                    textAlign: 'left'
                }
            ]
        }
    },
	mounted() {
        // 获取数据
        this.getData()
    },
	methods: {
        // 字体动态
        dvDigitalFlopConfig(item = {}) {
            let counts = parseFloat(item.value || 0)
            let config = {
                number: [parseFloat(counts)],
                textAlign: item.textAlign || 'center',
                style: {
                    fill: item.color || '#fff',
                    fontSize: item.fontSize || 32,
					fontFamily: 'DS-Digital-Bold'
                }
            }
            console.log('==config==', config)
            return config
        },
        // 获取数据
        getData() {
            // let that = this
            let params = { 
                enCode: 'computingpower-left-fwqgl',
            }
            dataInterface.dataFaceApi(params).then(res => {
                // console.log('computingpower-left-fwqgl', res)
                let data = res && res[0] || {}
                this.allNum.value = data.hostNum
                this.list[0].value = data.startNum
                this.list[1].value = data.stopNum
                this.list[2].value = data.otherNum
            })
        }
    }
}
</script>

<style lang="scss" scoped>
@import './comm.scss';
.com-partm1 {
    width: 100%;
    height: 300px;
    .p-content {
        width: 100%;
        height: calc(100% - $TitleHeight);
        .img {
            width: 137px;
            height: 106px;
            // background-color: red;
        }
        .i-list {
            .list-all {
                width: 160px;
            }
            .item {
                font-size: $FontSize20;
                padding: 10px 0;
                .item-l {
                    width: 10px;
                    height: 10px;
                    border-radius: 50%;
                    margin-right: 10px;
                }
                .item-c {
                    width: 80px;
                }
            }
        }
    }
}
</style>